import { Content } from '../../squidex';

export class ApplicationUserModel extends Content {
  constructor(current?: Content) {
    if (current) {
      super(current);
    } else {
      super({});
    }
  }
}
